import { useCallback } from 'react';
import { useToast } from 'hooks/useToast';
import { useAppSelector, useAppDispatch } from 'store/hooks/useStore';
import { ApiKeyTemplate } from 'types/apiKeyTemplate';
import * as templateApi from 'api/templateApi';
import {
  listSelectors,
  listActions,
} from 'store/reducers/apiKeyTemplateReducer/listSlice';
import { editActions } from 'store/reducers/apiKeyTemplateReducer/editSlice';

/**
 * APIキーテンプレート一覧 store の実装をコンポーネントから隠すための中間層
 * @returns selector と action のラッパー
 */
export const useListStore = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();

  const loading = useAppSelector(listSelectors.loading);
  const apiKeyTemplates = useAppSelector(listSelectors.apiKeyTemplates);

  const fetchApiKeyTemplates = useCallback(async () => {
    dispatch(listActions.loadStarted());
    const result = await templateApi.fetchApiKeyTemplates();
    if (result.ok) {
      dispatch(
        listActions.fetchApiKeyTemplateSuccess({
          apiKeyTemplates: result.value,
        }),
      );
    } else {
      toast({
        status: 'error',
        description: `APIキーテンプレート一覧の取得に失敗しました: ${result.err.message}`,
      });
    }
    dispatch(listActions.loadEnded());
  }, [dispatch, toast]);

  const onOpenModal = useCallback(
    async (apiKeyTemplate: ApiKeyTemplate) => {
      const id = apiKeyTemplate.id || 0;
      const result = await templateApi.fetchApiKeyTemplatesDetail(id);
      if (result.ok) {
        dispatch(
          editActions.fetchApiKeyTemplateDetailSuccess({
            apiKeyTemplate: result.value,
          }),
        );
      } else {
        toast({
          status: 'error',
          description: `APIキーテンプレート一覧の取得に失敗しました: ${result.err.message}`,
        });
      }
      dispatch(listActions.loadEnded());
    },
    [dispatch, toast],
  );

  return {
    /** 一覧ロード状態 */
    loading,
    /** APIキーテンプレート一覧データ */
    apiKeyTemplates,
    /** APIキーテンプレート一覧を取得 */
    fetchApiKeyTemplates,
    /** 詳細を表示 */
    onOpenModal,
  };
};
